import { back, push } from "@lagunovsky/redux-react-router";
import { store } from "index";

export const CustomizedPush = (path: string) => {
  store.dispatch(push(`${process.env.PUBLIC_URL}${path}`));
};

export const CustomizedBack = () => {
  store.dispatch(back());
};
